import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TOKEN_KEY = "harspro_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function authHeader() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const api = {
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data),
  me: () => axios.get(`${API}/auth/me`, { headers: authHeader() }).then((r) => r.data),
  submitContact: (payload) => axios.post(`${API}/contact`, payload).then((r) => r.data),
  listContacts: () =>
    axios.get(`${API}/admin/contacts`, { headers: authHeader() }).then((r) => r.data),
  updateContact: (id, status) =>
    axios
      .patch(`${API}/admin/contacts/${id}`, { status }, { headers: authHeader() })
      .then((r) => r.data),
  deleteContact: (id) =>
    axios.delete(`${API}/admin/contacts/${id}`, { headers: authHeader() }).then((r) => r.data),
};

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
